import { useEffect, useState } from 'react';
import { useReceiveMessage } from '../../../context/messageContext';
import { CornersFixation, FamiliarisationPhase, VisualFieldForthValleyTest } from '..';
import MainPanelContent from '../../patient/main-panel-content';

const VisualFieldForthValley = () => {
  const [currentTestStep, setCurrentTestStep] = useState('eyeMotility');
  const messageFromOptician = useReceiveMessage();

  useEffect(() => {
    if (messageFromOptician?.type === 'navigationMessage') setCurrentTestStep(messageFromOptician.content);
  }, [messageFromOptician]);

  const renderSwitch = () => {
    switch (currentTestStep) {
      case 'eyeMotility':
        return <CornersFixation />;
      case 'familiarisationPhase':
        return <FamiliarisationPhase />;
      case 'neuroSuiteTest':
        return <VisualFieldForthValleyTest />;
      default:
        return <MainPanelContent activeTab='holding' />;
    }
  };

  return renderSwitch();
};

export default VisualFieldForthValley;
